import { render, staticRenderFns } from "./DormRoomReservationDetailView.vue?vue&type=template&id=bd0a347e&scoped=true&"
import script from "./DormRoomReservationDetailView.vue?vue&type=script&lang=js&"
export * from "./DormRoomReservationDetailView.vue?vue&type=script&lang=js&"
import style0 from "./DormRoomReservationDetailView.vue?vue&type=style&index=0&id=bd0a347e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0a347e",
  null
  
)

export default component.exports